import Form from "../../ui/Form";
import CustomerField from "./CustomerField";
import CarField from "./CarField";
import DateField from "./DateField";
import { deliveryDate, printDate } from "../../utils/date.utils";
import {
  useCreateCustomerAttachmentMutation,
  useUpdateCustomerAttachmentMutation
} from "../../utils/customerAttachment.utils";
import { useNavigate } from "react-router-dom";
import InwordsTotalField from "./InwordsTotalField";
import CustomerBankField from "./CustomerBankField";
import CarAdditionalCost from "./CarAdditionalCost";
import CarDeliveryInfo from "./CarDeliveryInfo";
import { arrayMap } from "../../utils/array.utils";

export default function MoneyReceiptForm({
  title,
  defaultValues,
  onBack,
  existCustomer,
  redirectTo
}) {
  const navigate = useNavigate();

  const id = defaultValues?.id ?? null;

  let fields = [
    {
      name: "dateField",
      type: "custom",
      customComponent: DateField,
      col: { md: 12 }
    },
    {
      name: "customerField",
      type: "custom",
      customComponent: CustomerField,
      col: { md: 12 }
    }
  ];

  // conditionally car field handle for single and multiple
  if (defaultValues?.isMultiQuot) {
    defaultValues?.multiCars?.forEach((item, index) => {
      fields.push({
        name: `carField_${index}`,
        type: "custom",
        customComponent: CarField,
        col: { md: 12 },
        others: { sl: index, car: item, isMulti: defaultValues?.isMultiQuot }
      });
    });
  } else {
    fields.push({
      name: "carField",
      type: "custom",
      customComponent: CarField,
      col: { md: 12 },
      others: { defaultValues }
    });
  }

  // additional cost
  fields.push({
    name: "CarAdditionalCost",
    type: "custom",
    customComponent: CarAdditionalCost,
    col: { md: 12 },
    others: { defaultValues }
  });

  // price field
  fields.push({
    name: "inwordsTotalField",
    type: "custom",
    customComponent: InwordsTotalField,
    col: { md: 12 }
  });

  // delivery information
  fields.push({
    name: "CarDeliveryInfo",
    type: "custom",
    customComponent: CarDeliveryInfo,
    col: { md: 12 },
    others: { defaultValues }
  });

  // customer bank information field
  fields.push({
    name: "customerBankField",
    type: "custom",
    customComponent: CustomerBankField,
    col: { md: 12 }
  });

  // create attachement mutation
  const { loading, createCustomerAttachment } = useCreateCustomerAttachmentMutation([
    "createCustomerAttachment"
  ]);

  const { loading: updating, updateCustomerAttachment } = useUpdateCustomerAttachmentMutation([
    "updateCustomerAttachment"
  ]);

  // after create or update the page will redirect to money receipt list or customer money receipt list
  function handleRedirect() {
    if (redirectTo) {
      navigate(redirectTo);
    } else {
      navigate("/money-receipt-list");
    }
  }

  const onSubmit = async (values) => {
    const customer = values.customer;

    const po_collector_id = customer?.pay_order_collector_name?.value;

    const mrDate = printDate(values.mrDate);

    const expected_delivery_date = deliveryDate(customer.expected_delivery_date);

    const formattedData = { ...values, customer: { ...customer, expected_delivery_date }, mrDate };

    const strigifyData = JSON.stringify(formattedData);

    const { multiCars, isMultiQuot } = formattedData;

    let createData = {
      type_id: 2,
      attachment: strigifyData,
      customer_id: values?.customer?.customer_id ?? "",
      is_multi: isMultiQuot,
      po_collector_id
    };

    if (isMultiQuot && multiCars?.length) {
      createData.stock_list_ids =
        arrayMap(multiCars, (item) => item.id ?? item?.stock_list_id) || [];
    } else {
      createData.stock_list_ids = values?.car?.stock_list_id ? [values?.car?.stock_list_id] : [];
    }

    // update
    if (!!id) {
      const afterUpdated = await updateCustomerAttachment({ id, ...createData });

      if (afterUpdated?.status === 200) {
        handleRedirect();
      }
      return;
    }

    // create
    const afterCreated = await createCustomerAttachment({ ...createData });

    if (afterCreated?.status === 201) {
      handleRedirect();
    }
  };

  const isLoading = loading || updating;

  return (
    <Form
      fields={fields}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      submitbtnText={isLoading ? `${!!id ? "Editing..." : "Adding...."}` : title}
      loading={typeof isLoading === "boolean" ? isLoading : undefined}
      closebtnText={"Back"}
      onClose={onBack}
    />
  );
}
